import { Link } from 'react-router-dom';
import {
  ChartBarIcon,
  UsersIcon,
  BuildingOfficeIcon,
  BriefcaseIcon,
  MapPinIcon,
  CurrencyEuroIcon,
  CalendarIcon,
  ChartPieIcon,
  PresentationChartBarIcon,
  GlobeAltIcon,
  ArrowRightIcon,
  BuildingOffice2Icon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';
import Header from '../components/Header';

type ReportIcon = ComponentType<SVGProps<SVGSVGElement>>;

const reports: { name: string; path: string; Icon: ReportIcon }[] = [
  { name: 'Estimated Revenue per Manager', path: '/report/estimated-revenue', Icon: ChartBarIcon },
  { name: 'Group Series Open Requests', path: '/report/group-series', Icon: UsersIcon },
  { name: 'Materialization per Client / Manager', path: '/report/materialization-per-client', Icon: BuildingOfficeIcon },
  { name: 'Materialization per Client / Hotel', path: '/report/materialization-per-client-hotel', Icon: BuildingOfficeIcon },
  { name: 'Materialization per Client / City', path: '/report/client-hotel-materialization', Icon: BuildingOfficeIcon },
  { name: 'Materialization per Country / Hotel', path: '/report/destination-hotel-materialization', Icon: MapPinIcon },
  { name: 'Materialization per Segment', path: '/report/materialization-per-segment', Icon: ChartPieIcon },
  { name: 'Materialization per Market / Client', path: '/report/materialization-per-market-client', Icon: GlobeAltIcon },
  { name: 'Average Rates per City', path: '/report/average-rates-per-city', Icon: CurrencyEuroIcon },
  { name: 'Lost Business Report', path: '/report/lost-business', Icon: BriefcaseIcon },
  { name: 'Leadership Team Sales update', path: '/report/leadership-sales-update', Icon: ChartBarIcon },
  { name: 'Hotels Performance', path: '/report/hotels-performance', Icon: BuildingOffice2Icon },
  { name: 'Created / Confirmed Revenue', path: '/report/created-confirmed-revenue', Icon: ChartBarIcon },
  { name: 'Groups per Month', path: '/report/groups-per-month', Icon: CalendarIcon },
  { name: 'Meeting Preparation', path: '/report/meeting-preparation', Icon: PresentationChartBarIcon },
];

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="mx-auto max-w-6xl px-4 pb-16 pt-10 sm:px-6 lg:px-8">
        <header className="mb-10 max-w-2xl">
          <h1 className="page-title">Reports</h1>
        </header>

        <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {reports.map(({ name, path, Icon }) => (
            <li key={path}>
              <Link
                to={path}
                className="group flex h-full flex-col overflow-hidden rounded-xl border border-slate-200/90 bg-white shadow-sm transition-all duration-200 ease-out hover:-translate-y-0.5 hover:border-action/40 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-action/45 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50"
              >
                <div className="bg-[#F9FAFB] px-5 py-4 transition-colors duration-200 group-hover:bg-action-surface">
                  <Icon className="h-7 w-7 shrink-0 text-action" aria-hidden />
                </div>
                <div className="flex flex-1 items-start justify-between gap-4 px-5 py-4">
                  <span className="text-left text-sm font-medium leading-snug text-action">{name}</span>
                  <ArrowRightIcon
                    className="mt-0.5 h-4 w-4 shrink-0 text-action transition-transform duration-200 group-hover:translate-x-0.5"
                    aria-hidden
                  />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
